var app = app ||  {};
app.categoria = app.categoria || {};

;(function(namespace, $){

  var Categoria = function() {

    function CadastraCategoria() {
      var validate_form = new lcssafira.form.ValidateForm('form-categoria');
    }

    // function BuscaPcc() {
    //   $('#form-busca-pcc').submit(function(event) {
    //     event.preventDefault();
    //     var data = $(this).serialize();
    //     app.datatable.initDataTable(true, false, '?' + data, 'pcc', '/pcc/consultar');
    //   });
    // }

    // function loadCategories() {
    //   var btn_categoria,
    //       table,
    //       id_categorie,
    //       el_table_name,
    //       el_table_col,
    //       el_id_categoria,
    //       el_select_id;

    //   btn_categoria = $('.categorias');
    //   el_table_name = $('#table-name');
    //   el_table_col = $('#table-col');
    //   el_id_categoria = $('#id-categoria');

    //   btn_categoria.bind('change', function(event) {
    //     _self = $(this);
    //     table = _self.attr('data-table');
    //     id_categorie = _self.val();
    //     el_select_id = _self.attr('id');

    //     el_table_name.val(table);
    //     el_id_categoria.val(id_categorie);
    //     el_table_col.val(el_select_id);

    //     if(table == '')
    //       return false

    //     app.ajaxrequest.initialize('/categorias-mkt/' + table, 'get', 'json', { table: table, id_categoria: id_categorie, 'where_colum' : el_select_id }, app.pcc.responseCategories);
    //   });
    // }

    // function responseCategories(data) {
    //   var selects_holder,
    //       el_select_id,
    //       next_select;

    //   selects_holder = $('#categories-row');

    //   el_select_id = $('#' + data[1]['table']);
    //   el_select_id.html('');
      
    //   $.each(data[0], function(index, val) {
    //     el_select_id.append('<option value="' + val.id_categoria + '">' + val.nome_categoria + '</option>');
    //   });

    //   el_select_id.selectpicker('refresh');
    // }


    function _construct() {
      CadastraCategoria();

      app.staticdatatable.staticDataTable('categorias-table');
      var message = "A remoção de uma categoria implica na exclusão de qualquer dado vinculado a ela.";
      var confirm_modal = new lcssafira.confirmmodal.ConfirmModal('.remove-categoria', message);
    }

    // namespace.responseCategories = responseCategories;
    // namespace.responsePcc = responsePcc;
    _construct();

  };

  var main = new Categoria();

})(app.categoria, jQuery);


